"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FetchTranslationsWithNamespacesOptions = require("./FetchTranslationsWithNamespacesOptions");
Object.keys(_FetchTranslationsWithNamespacesOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FetchTranslationsWithNamespacesOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FetchTranslationsWithNamespacesOptions[key];
    }
  });
});
var _Language = require("./Language");
Object.keys(_Language).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Language[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Language[key];
    }
  });
});
var _Translations = require("./Translations");
Object.keys(_Translations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Translations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Translations[key];
    }
  });
});
var _TranslationsWithNamespaces = require("./TranslationsWithNamespaces");
Object.keys(_TranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationsWithNamespaces[key];
    }
  });
});
var _ValuesArgForMessage = require("./ValuesArgForMessage");
Object.keys(_ValuesArgForMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ValuesArgForMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ValuesArgForMessage[key];
    }
  });
});
var _ExtractPlaceholders = require("./ExtractPlaceholders");
Object.keys(_ExtractPlaceholders).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ExtractPlaceholders[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ExtractPlaceholders[key];
    }
  });
});
//# sourceMappingURL=index.js.map